import { safeDivide } from "@north-beam/nb-common";
import { Select } from "@shared/selects";

import { type RebudgetingTableRow } from "./mid-cycle-rebudgeting-table";

const SORT_OPTIONS = [
  {
    value: "actual_over_budgeted_to_date_asc",
    label: "Ratio, Actual vs Budgeted $(Low - High)",
  },
  {
    value: "actual_over_budgeted_to_date_dsc",
    label: "Ratio, Actual vs Budgeted $(High - Low)",
  },
  {
    value: "actual_minus_budgeted_asc",
    label: "Difference, Actual vs Budgeted $ (Low - High)",
  },
  {
    value: "actual_minus_budgeted_desc",
    label: "Difference, Actual vs Budgeted $ (High - Low)",
  },
  { value: "total_spend_actual_asc", label: "Total $, Actual (Low - High)" },
  { value: "total_spend_actual_desc", label: "Total $, Actual (High - Low)" },
  {
    value: "total_spend_budgeted_asc",
    label: "Total $, Budgeted (Low - High)",
  },
  {
    value: "total_spend_budgeted_desc",
    label: "Total $, Budgeted (High - Low)",
  },
];

export const DEFAULT_SORT = SORT_OPTIONS[0].value;

const sortRows = (sort: string) => {
  switch (sort) {
    case "actual_over_budgeted_to_date_asc":
      return (a: RebudgetingTableRow, b: RebudgetingTableRow) => {
        const aDiff = safeDivide(
          a.data.actualSpend,
          a.data.budgetedSpendToDate,
        );
        const bDiff = safeDivide(
          b.data.actualSpend,
          b.data.budgetedSpendToDate,
        );
        return aDiff - bDiff;
      };
    case "actual_over_budgeted_to_date_desc":
      return (a: RebudgetingTableRow, b: RebudgetingTableRow) => {
        const aDiff = safeDivide(
          a.data.actualSpend,
          a.data.budgetedSpendToDate,
        );
        const bDiff = safeDivide(
          b.data.actualSpend,
          b.data.budgetedSpendToDate,
        );
        return bDiff - aDiff;
      };
    case "actual_minus_budgeted_asc":
      return (a: RebudgetingTableRow, b: RebudgetingTableRow) => {
        const aDiff = a.data.actualSpend - a.data.budgetedSpend;
        const bDiff = b.data.actualSpend - b.data.budgetedSpend;
        return aDiff - bDiff;
      };
    case "actual_minus_budgeted_desc":
      return (a: RebudgetingTableRow, b: RebudgetingTableRow) => {
        const aDiff = a.data.actualSpend - a.data.budgetedSpend;
        const bDiff = b.data.actualSpend - b.data.budgetedSpend;
        return bDiff - aDiff;
      };
    case "total_spend_actual_asc":
      return (a: RebudgetingTableRow, b: RebudgetingTableRow) =>
        a.data.actualSpend - b.data.actualSpend;
    case "total_spend_actual_desc":
      return (a: RebudgetingTableRow, b: RebudgetingTableRow) =>
        b.data.actualSpend - a.data.actualSpend;
    case "total_spend_budgeted_asc":
      return (a: RebudgetingTableRow, b: RebudgetingTableRow) =>
        a.data.budgetedSpend - b.data.budgetedSpend;
    case "total_spend_budgeted_desc":
      return (a: RebudgetingTableRow, b: RebudgetingTableRow) =>
        b.data.budgetedSpend - a.data.budgetedSpend;
    default:
      return () => 0;
  }
};

export const sortControl = (sort: string) => (rows: RebudgetingTableRow[]) =>
  rows
    .map((row) => ({
      ...row,
    }))
    .sort(sortRows(sort)) as RebudgetingTableRow[];

export const TableSorter = ({
  sort,
  setSort,
}: {
  sort: string;
  setSort: (val: string) => void;
}) => (
  <div className="flex justify-end">
    <div className="flex flex-col space-y-1 -mt-3">
      <span className="text-sm">Sort</span>
      <Select value={sort} onChange={setSort} options={SORT_OPTIONS} />
    </div>
  </div>
);
